/**
 * Pure helpers for the admin Billing panel (checkout-link generation).
 * No React, no i18next instance — kept importable from unit tests without
 * mounting the page (see preSignatureRows.js for the same pattern; Admin.jsx
 * imports these).
 */

/**
 * Builds the POST /admin/billing/checkout-link request body for the given
 * mode. The backend 422s if both workspace_id and owner_email/workspace_name
 * are present, so the two modes must stay mutually exclusive here.
 */
export function buildCheckoutLinkBody(mode, { workspaceId, plan, interval, email, company }) {
  const body = { plan, interval };
  if (mode === "upgrade") {
    body.workspace_id = workspaceId;
  } else {
    body.owner_email = email;
    body.workspace_name = company;
  }
  return body;
}

/**
 * Maps an axios-style error (or anything falsy) from the checkout-link
 * endpoint to an i18n key. Order matters: the 2FA gate fires before the
 * Stripe-configured check on the backend, so mfa_required is checked first.
 */
export function checkoutLinkErrorKey(err) {
  const status = err?.response?.status;
  const code = err?.response?.data?.detail?.code;
  if (code === "mfa_required") return "billing.error_mfa";
  if (status === 503) return "billing.error_unconfigured";
  return "billing.error_generic";
}
